/**
 * Central feature flags (CRA: set via REACT_APP_* in .env).
 *
 * Property sale listings (buy / for-sale / sold) depend on account + property APIs.
 * When disabled, related UI is hidden and those fetches are not started.
 */

function parseBooleanEnv(value, defaultValue) {
  if (value === undefined || value === null || value === '') {
    return defaultValue;
  }
  const normalized = String(value).trim().toLowerCase();
  if (['true', '1', 'yes', 'on'].includes(normalized)) {
    return true;
  }
  if (['false', '0', 'no', 'off'].includes(normalized)) {
    return false;
  }
  return defaultValue;
}

/** When false (default), buy / sell / sold listing UI and their initial API calls are off. */
export function isPropertySaleApiEnabled() {
  return parseBooleanEnv(process.env.REACT_APP_ENABLE_PROPERTY_SALE_API, false);
}
